import { useMemo } from 'react'

import PageContext, { PageContextPayload } from '@contexts/pageContext'

import { useModals, useSetState } from '@domain-group/react-hooks'

import CreateOrEditAgencyProviderModal from '@modals/CreateOrEditAgencyProviderModal'

import { ModalContext } from '@domain-group/suit-theme'

import type { AgencyModel, AgencyProviderModel } from '@models/types'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

interface RelationsProps {
  agency: AgencyModel,
}

const defaultState = {
  showCreateOrEditAgencyProviderModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: string, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditAgencyProviderModal: {
      closeModal: () => setState({ showCreateOrEditAgencyProviderModal: false }),
      createAgencyProvider: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateAgencyProvider: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const Relations = (props: RelationsProps) => {
  const { agency } = props
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditAgencyProviderModal } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreateOrEditAgencyProviderModal: (payload: { agencyProvider: AgencyProviderModel }) => {
        setModalData('CreateOrEditAgencyProviderModal', payload)
        setState({ showCreateOrEditAgencyProviderModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent agency={agency} />

        <CreateOrEditAgencyProviderModal
          callbacks={callbacks('CreateOrEditAgencyProviderModal', setState)}
          hideAgencyAndBrand
          showModal={showCreateOrEditAgencyProviderModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Relations
